import { useMemo } from "react";

import useModule from "./useModule";
import { getMetadataFieldInfo } from "../utils/RecordUtils";
import { Module } from "../types/TenantInterfaces";

interface Props {
  module?: Module | null;
  moduleAPIName?: string;
}

const useRecordMetadata = ({ module, moduleAPIName }: Props) => {
  const { module: foundModule } = useModule(moduleAPIName);

  const finalModule = module || foundModule;

  const metadataFieldInfo = useMemo(() => {
    if (!finalModule) return [null, null];

    return getMetadataFieldInfo(finalModule);
  }, [finalModule]);

  return {
    metadataField: metadataFieldInfo[0],
    metadataFieldType: metadataFieldInfo[1],
  };
};

export default useRecordMetadata;
